import React from "react";
import { Box } from "@mui/material";
import ConnectLoader from "../assets/images/connectloader.svg";

const MegaLoader = ({ loading }) => {
  if (!loading) return null; // If loading is false, do not render the component

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(255, 255, 255, 0.5)", // Adjust opacity as needed
        backdropFilter: "blur(1px)",
        zIndex: 9999,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Box
        sx={{
          position: "fixed",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
        }}
      >
        <img
          src={ConnectLoader}
          alt="Loading..."
          style={{ color: "#374ad7", width: 90, height: 90 }}
        />
      </Box>
    </div>
  );
};

export default MegaLoader;
